module.exports = __webpack_public_path__ + "images/default_avatars/waves-2a1f5efa6dec70c2b17b47e73e9fb1a4.jpg";